import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import useCatalogo from "../../../hooks/useCatalogos"
import { useDispatch, useSelector } from "react-redux"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { obtenerDevolucionesHistorialFiltroAction } from "../../../ducks/devolucionesHistorial"
const FiltroEstatusDevolucion = () => {
    const catEstatusDevolucion = useCatalogo("Refound/Status")
    const { filtroEstatus } = useSelector(store => store.devolucionesHistorial)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerDevolucionesHistorialFiltroAction({filtroEstatus:  event.target.value})).then(Response => {
            dispatch(offLoadAction())
        })
    }
    return (
        <FormControl variant="outlined">
            <InputLabel id="Filtro-estatus-select-devolcuon-label">Filtro</InputLabel>
            <Select
                labelId="Filtro-estatus-select-devolcuon-label"
                id="Filtro-estatus-select-devolcuon"
                value={filtroEstatus}
                onChange={handleChange}
                label="Filtro"
            >
                {
                    catEstatusDevolucion.map((valor, index) => {
                        return (
                            <MenuItem key={valor.IdCatEstatusDevolucion} value={valor.IdCatEstatusDevolucion}>
                                {valor.Descripcion}
                            </MenuItem>
                        )
                    })
                }
            </Select>
        </FormControl>
    )
}
export default FiltroEstatusDevolucion